export default "__VITE_ASSET__Z8lMNIsV__"